import { render, staticRenderFns } from "./deviceParameter.vue?vue&type=template&id=c1dae8fe&scoped=true&"
import script from "./deviceParameter.vue?vue&type=script&lang=js&"
export * from "./deviceParameter.vue?vue&type=script&lang=js&"
import style0 from "./deviceParameter.vue?vue&type=style&index=0&id=c1dae8fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1dae8fe",
  null
  
)

export default component.exports